import ALazyMonkeyPagination from './ALazyMonkeyPagination';
import InfiniteScrollPlaceholder from './classes/InfiniteScrollPlaceholder';

export default class LazyMonkeyInfiniteScroll extends ALazyMonkeyPagination {
  protected initializeLoader(nextPageLink: string): void {
    const doc = document;
    const placeholder = new InfiniteScrollPlaceholder(
      doc,
      this.settings.infiniteMarkup,
      this.settings.infiniteScrollLoadThreshold
    );
    this.pageUpdater.replacePagination(
      placeholder.createElement(() => {
        this.addNextPagePosts(nextPageLink);
      })
    );
  }
  protected removeLoader(): void {
    this.pageUpdater.replacePagination(null);
  }
}
